<template>

  <div class="list-bed"
       v-if="yearList.length>0">
    <div class="list-li"
         v-for="(item, index) in yearList"
         :key="index">
      <div class="li-title"><span>{{item.type=='OLD'?"老年卡":item.type=='STUDENT'?"学生卡":item.type=='LOVE'?"爱心卡":''}}年审</span><span style="color:#EF8441"
              v-if="item.audit_status=='00'">待支付</span>
        <span style="color:#EF8441"
              v-if="item.audit_status=='01'">待审核</span>
        <span style="color:#2489FF"
              v-if="item.audit_status=='02'">年审完成</span>
        <span style="color:#ef4141"
              v-if="item.audit_status=='99'">审核未通过</span>
      </div>
      <div class="li-con">
        <div class="li-box">
          <div class="li-key">提交时间</div>
          <div class="li-val">{{item.submitDate}}</div>
        </div>
        <div class="li-box">
          <div class="li-key">年审卡号</div>
          <div class="li-val">{{item.cardNo}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="list-li">
      <div class="li-title"><span>爱心卡年审</span><span style="color:#2489FF">年审完成</span></div>
      <div class="li-con">
        <div class="li-box">
          <div class="li-key">提交时间</div>
          <div class="li-val">2022-02-02 09:54</div>
        </div>
        <div class="li-box">
          <div class="li-key">年审卡号</div>
          <div class="li-val">4111022550041458</div>
        </div>
      </div>
    </div>
    <div class="list-li">
      <div class="li-title"><span>老年卡年审</span><span style="color:#2489FF">年审完成</span></div>
      <div class="li-con">
        <div class="li-con">
          <div class="li-box">
            <div class="li-key">提交时间</div>
            <div class="li-val">2022-02-02 09:54</div>
          </div>
          <div class="li-box">
            <div class="li-key">年审卡号</div>
            <div class="li-val">4111022550041458</div>
          </div>
        </div>
      </div>
    </div> -->

  </div>
  <div v-else>
    <img src="../assets/img/no_list.png"
         style="width:320px;height:302px" />
  </div>

</template>

<script>
import TitleBar from '@/components/TitleBar'

export default {
  name: 'listYearChecked',
  data () {
    return {
      loading: true
    }
  },
  props: {
    yearList: {
      type: Array,
      // requireed: true

    }
  },

  components: {


  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {


  },
  methods: {
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  background: #f5f6f8;
  min-height: 100%;
  overflow: scroll;
}
.img-bed {
  font-size: 0;
  background: #fff;
}
.type-list {
  width: calc(100% - 64px);
  height: 94px;
  margin-left: 32px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  li {
    width: 25%;
    font-size: 30px;
    font-family: 宋体;
    font-weight: 400;
    color: #8f98a8;
  }
}
.menu-list {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  > .list-bed {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    // flex-wrap: wrap;
    width: 100%;

    > .list-li {
      // border-bottom: 3px solid #eee;
      width: calc(100% - 64px);
      // height: 330px;
      margin-bottom: 16px;
      padding-bottom: 4px;
      // box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      .li-title {
        width: calc(100% - 48px);
        height: 82px;
        border-bottom: 1px solid #e8ebf0;
        font-size: 30px;
        font-family: 宋体;
        font-weight: 500;
        color: #333333;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .li-con {
        width: calc(100% - 48px);
        padding-top: 16px;

        .li-box {
          height: 37px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: left;
          margin-bottom: 20px;
          .li-key {
            width: 30%;
            height: 100%;
            font-size: 26px;
            font-family: 宋体;
            font-weight: 400;
            color: #8f98a8;
          }
          .li-val {
            width: 70%;
            height: 100%;
            font-size: 26px;
            font-family: 宋体;
            font-weight: 400;
            color: #333333;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>
